export const css = {
    root: '_1mWTUBXK',
    pane: '_1TXkLJkt',
    heading: 'KP3h3Y6Q',
    body: '_3W9tVRPz',
    exit: '_391wJW4b',
    collapse: '_1_TR3VD6',
    enter: '_1qtTr3iU',
    expand: '_1ByN6R-A',
    ' _key': 'afcpe-theme/afcpe/base-widgets/accordion2'
};
export default css;
